import { jsxs as i, jsx as s } from "react/jsx-runtime";
import { c as l } from "../../../clsx-OuTLNxxd.js";
const n = "_loader_1ksyv_29", c = "_circle_1ksyv_41", e = {
  loader: n,
  "is-small": "_is-small_1ksyv_29",
  "is-medium": "_is-medium_1ksyv_33",
  "is-large": "_is-large_1ksyv_37",
  circle: c,
  "moving-element": "_moving-element_1ksyv_44",
  "on-dark": "_on-dark_1ksyv_47",
  "is-secondary": "_is-secondary_1ksyv_53",
  "dialog-overlay-show": "_dialog-overlay-show_1ksyv_1",
  "dialog-content-show": "_dialog-content-show_1ksyv_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1ksyv_1"
}, d = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large"
}, m = {
  primary: "is-primary",
  secondary: "is-secondary"
};
function k({ onDark: r, size: o = "medium", color: a = "primary", className: t }) {
  return /* @__PURE__ */ i(
    "svg",
    {
      className: l(
        e.loader,
        e[d[o]],
        e[m[a]],
        r && e["on-dark"],
        t
      ),
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      children: [
        /* @__PURE__ */ s("rect", { width: "100", height: "100", fill: "none", className: "bk" }),
        /* @__PURE__ */ s("circle", { className: e.circle, cx: "50", cy: "50", r: "40", fill: "none", strokeWidth: "10", strokeLinecap: "round" }),
        /* @__PURE__ */ i(
          "circle",
          {
            className: e["moving-element"],
            cx: "50",
            cy: "50",
            r: "40",
            fill: "none",
            strokeWidth: "6",
            strokeLinecap: "round",
            children: [
              /* @__PURE__ */ s("animate", { attributeName: "stroke-dashoffset", dur: "2s", repeatCount: "indefinite", from: "502", to: "0" }),
              /* @__PURE__ */ s(
                "animate",
                {
                  attributeName: "stroke-dasharray",
                  dur: "2s",
                  repeatCount: "indefinite",
                  values: "150.6 100.4;1 250;150.6 100.4"
                }
              )
            ]
          }
        )
      ]
    }
  );
}
export {
  k as Loader
};
